import { render, staticRenderFns } from "./tree-select-widget.vue?vue&type=template&id=c09d15d2&scoped=true&"
import script from "./tree-select-widget.vue?vue&type=script&lang=js&"
export * from "./tree-select-widget.vue?vue&type=script&lang=js&"
import style0 from "./tree-select-widget.vue?vue&type=style&index=0&id=c09d15d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09d15d2",
  null
  
)

export default component.exports